import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { StarIcon, BadgeCheckIcon, ArrowRightIcon } from 'lucide-react';
const testimonials = [{
  name: 'Ana',
  age: 34,
  location: 'Miami, FL',
  image: 'https://cdn.magicpatterns.com/uploads/82hR8v9bo8iTXav3Wihqf8/testimonio_1.png',
  text: 'Antes de este protocolo yo vivía pegada al celular. Me despertaba de madrugada para revisar si estaba en línea y me inventaba conversaciones en mi cabeza todo el día. Empecé el PRD con cero contacto real y la técnica de los 90 segundos; los primeros días fueron intensos, pero por primera vez sentí que podía atravesar la ansiedad sin actuar. A la segunda semana ya no revisaba sus redes y volví a dormir mejor. Hoy no digo "ya no me duele", digo "ya no me controla".'
}, {
  name: 'Luis',
  age: 41,
  location: 'Houston, TX',
  image: 'https://cdn.magicpatterns.com/uploads/oySuWL5qxJQArELrBNfVfZ/testimonio_2_.png',
  text: 'Me costaba aceptar que estaba atrapado en un ciclo: esperar un mensaje, sentir alivio, volver a caer. Este protocolo me dio estructura. La parte de disparadores y el inventario de la verdad me ayudaron a dejar de idealizar. Lo que más me sorprendió fue recuperar energía para mi trabajo y mi familia. No fue instantáneo, pero sí real: cada día tuve herramientas concretas para mantenerme firme. Ahora tengo límites claros y me siento otra vez dueño de mi mente.'
}, {
  name: 'Sofía',
  age: 29,
  location: 'Bogotá, CO',
  image: 'https://cdn.magicpatterns.com/uploads/i4f5VSRvMmqHHR88wTYcKF/testimonio_3.png',
  text: 'Yo pensaba que "amar" era aguantar, insistir y demostrar. Este libro me hizo entender que también existe el amor propio con límites. Con el tracker y las plantillas empecé a ver mi patrón y a romperlo. Lo más valioso fue aprender a no buscar calma en la misma persona que me quitaba la paz. Después de 21 días, me siento más tranquila, más enfocada, y con una claridad que antes no tenía. No volví a ser la misma: volví a ser yo.'
}];
function StarRating() {
  return <div className="flex gap-0.5" data-id="element-159">
      {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-brand-amber text-brand-amber" data-id="element-160" />)}
    </div>;
}
function VerifiedBadge() {
  return <span className="inline-flex items-center gap-1.5 text-xs font-medium text-green-400/80" data-id="element-161">
      <BadgeCheckIcon className="w-3.5 h-3.5" data-id="element-162" />
      Compra verificada
    </span>;
}
export function TestimonialsSection() {
  return <section className="py-16 md:py-24 px-4 bg-brand-slate/30" data-id="element-163">
      <div className="max-w-6xl mx-auto" data-id="element-164">
        {/* Header */}
        <FadeIn data-id="element-165">
          <div className="text-center mb-14" data-id="element-166">
            <h3 className="font-serif text-3xl md:text-4xl text-white mb-4 leading-tight" data-id="element-167">
              Historias reales de personas que recuperaron su paz
            </h3>
            <p className="text-brand-text/70 text-lg max-w-2xl mx-auto" data-id="element-168">
              Resultados después de aplicar el PRD (sin rogar, sin stalkear, sin
              perder la dignidad).
            </p>
          </div>
        </FadeIn>

        {/* Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-14" data-id="element-169">
          {testimonials.map((t, i) => <FadeIn key={i} delay={i * 0.15} data-id="element-170">
              <div className="h-full flex flex-col bg-[#1e293b]/80 border border-white/5 rounded-2xl p-7 hover:border-brand-amber/20 transition-colors" data-id="element-171">
                {/* Avatar + info */}
                <div className="flex items-center gap-4 mb-5" data-id="element-172">
                  <div className="w-14 h-14 rounded-full overflow-hidden flex-shrink-0 border-2 border-brand-amber/30" data-id="element-173">
                    <img src={t.image} alt={t.name} className="w-full h-full object-cover" data-id="element-174" />
                  </div>
                  <div data-id="element-175">
                    <p className="text-white font-semibold text-base" data-id="element-176">
                      {t.name}, {t.age}
                    </p>
                    <p className="text-brand-muted text-sm" data-id="element-177">{t.location}</p>
                  </div>
                </div>

                {/* Testimonial text */}
                <p className="text-brand-text/80 text-[15px] leading-relaxed flex-grow mb-5" data-id="element-178">
                  "{t.text}"
                </p>

                {/* Rating + badge */}
                <div className="flex items-center justify-between pt-4 border-t border-white/5" data-id="element-179">
                  <StarRating data-id="element-180" />
                  <VerifiedBadge data-id="element-181" />
                </div>
              </div>
            </FadeIn>)}
        </div>

        {/* CTA */}
        <FadeIn delay={0.3} data-id="element-182">
          <div className="flex flex-col items-center gap-4" data-id="element-183">
            <button onClick={() => {
            const el = document.getElementById('precio');
            if (el) el.scrollIntoView({
              behavior: 'smooth'
            });
          }}
          // Note: AddToCart fires on the final purchase button, not this scroll button
          className="px-8 py-4 bg-brand-amber hover:bg-brand-amberHover text-brand-darker font-bold text-sm md:text-base rounded-full uppercase tracking-wider shadow-[0_0_20px_rgba(212,165,116,0.2)] hover:shadow-[0_0_30px_rgba(212,165,116,0.4)] transition-all flex items-center gap-3" data-id="element-184">
              Descargar el Protocolo por $6.99
              <ArrowRightIcon className="w-5 h-5" data-id="element-185" />
            </button>
          </div>
        </FadeIn>
      </div>
    </section>;
}